import { LinearProgress } from '@mui/material';
import React from 'react';

export default function LoaderOrNoData({
  type = 'loader'
}: {
  type: 'loader' | 'no-data';
}) {
  if (type === 'loader') {
    return (
      <div style={{ padding: '10px 0px' }}>
        <LinearProgress />
      </div>
    );
  }

  if (type === 'no-data') {
    return <div style={{ padding: '10px 0px' }}>No data found</div>;
  }
}
